/**
 * What the membership includes, as a fallback when the server's configured list is unavailable.
 *
 * ONE COPY, DELIBERATELY. This list existed in three places — the server's `Stripe:Subscription:
 * Features`, the subscription page, and the paywall dialog — and they had drifted: two of them were
 * still advertising things that are not true.
 *
 * "Unlimited virtual consultations" is the important one. Video visits are a separately priced
 * exception now ($200 patient-requested / $75 clinician-required), so selling unlimited
 * consultations beside a per-visit charge is the kind of claim that becomes a chargeback argument
 * rather than a support ticket. "Advanced headache tracking" and "lifestyle coaching" were also
 * there and do not exist at all.
 *
 * The SERVER's list wins wherever it is available; this is what shows when it is not.
 */
// "Prior-authorization support" looks unbacked in code — the entire implementation is
// requiresPriorAuth() prefixing a bracketed string to a free-text notes field — and it was queried
// on that basis on 2026-09-09. It STAYS: clinic staff genuinely chase prior authorizations
// off-system, so it describes a service rather than a screen (Derek, decision B10(b)). Do not
// remove it as false the way "Advanced headache tracking" was.
export const FALLBACK_PLAN_FEATURES = [
  "Headache assessment reviewed by a specialist",
  "Treatment plan and prescriptions when appropriate",
  "Prescription refills and continuity of care",
  "Prior-authorization support",
  "Secure messaging with your care team",
];
